
import { createConfirmation } from 'react-confirm';
import confirmModal from './confirm-modal';

export const confirm = createConfirmation(confirmModal);
